/**
 * Created by coolguy on 2017/7/5.
 */
import React from 'react';
import {message,Row} from 'antd';
import Info from '../Detail/Info';
import Add from '../HighListComponent/Add';
import g from './const';
import Check from '../../util/CheckList';
class TheAdd extends React.Component {
    checkInput = (state)=> {
        let {name,consumerid,mobile,email} = state;
        if (!name) {
            message.warn("请填写姓名");
            return false;
        }
        if(!consumerid || isNaN(consumerid)){
            message.warn("请填写正确的客户名称");
            return false;
        }
        if (!Check.mobile(mobile)) {
            message.warn("请输入正确的手机号");
            return false;
        }
        if(email && !Check.emailCheck(email)){
            message.warn("请输入正确的邮箱地址");
            return false;
        }
        return true;
    };
    handleData = (data)=> {
        if (!this.checkInput(data)) {
            return false;
        }
        let formData = Object.assign({}, data);
        delete formData.createby;
        delete formData.consumer;
        return formData;
    };
    render() {
        let {state,consumerid} = this.props;
        return (
            <div id="addBill">
                <Row type="flex" align="middle">
                    <Info label="姓名" value={state.name} required
                          onChange={(value)=>this.props.setKeyValue("name",value)}/>
                </Row>
                <Row type="flex" align="middle">
                    {state.createby &&
                    <Info label="创建人" value={state.createby.nickname+"/"+state.createby.phone} isText/>}
                </Row>
                <Row type="flex" align="middle">
                    <Info label="客户名称" value={state.consumerid} required type="consumer" consumerObj={state.consumer}
                          onChange={(value)=>this.props.setKeyValue("consumerid",value)}/>
                </Row>
                <Row type="flex" align="middle">
                    <Info label="手机号" value={state.mobile} required
                          onChange={(value)=>this.props.setKeyValue("mobile",value)}/>
                    <Info label="邮箱" value={state.email}
                          onChange={(value)=>this.props.setKeyValue("email",value)}/>
                </Row>

                <Row type="flex" align="middle">
                    <Info label="部门" value={state.department}
                          onChange={(value)=>this.props.setKeyValue("department",value)}/>
                    <Info label="头衔" value={state.title}
                          onChange={(value)=>this.props.setKeyValue("title",value)}/>
                </Row>
                <Row type="flex" align="middle">
                    <Info label="地址" value={state.address}
                          onChange={(value)=>this.props.setKeyValue("address",value)}/>
                </Row>
                <Row type="flex" align="middle">
                    <Info label="关键决策人" value={state.important || "0"} type="radio" data={[{key:"0",name:"否"},{key:"1",name:"是"}]}
                          onChange={(value)=>this.props.setKeyValue("important",value)}/>
                </Row>
            </div>
        )
    }
}

export default Add({type:"contact",name:"联系人", rowKey:"id"})(TheAdd);



// WEBPACK FOOTER //
// ./src/components/ContactList/Add.js